// kaffe, kiumba, stambolov, eji, oeuf, besson, diaz, tiab, shanghai, jazzual, lede

import chris from '../media/chris-potter.png';
import tigran from '../media/tigran-hamasaya.png';
import anomalie from '../media/anomalie.jpg';
import bertaut from '../media/bertaut.jpg';
import dooz from '../media/dooz.png';
import foehn from '../media/foehn.jpg';
import garcia from '../media/garcia.jpg';
import glasper from '../media/glasper.jpg';
import glyk from '../media/glyk.jpeg';
import yellowstraps from '../media/yellowstraps.jpg';
import henry from '../media/cory.jpg';

import CSW from '../media/CSW.jpg';
import CSW2 from '../media/CSW_square.jpg';
import Emile from '../media/emile2.jpg';
import Emile2 from '../media/emile.jpg';
import GTO from '../media/GTO.jpg';
import GTO2 from '../media/GTO2.jpg';
import Jet from '../media/jet.jpg';
import Jet2 from '../media/jet2.jpg';
import Phal from '../media/phal.png';
import Phal2 from '../media/phal2.jpg';
import Oscar from '../media/oscar.png';
import Oscar2 from '../media/oscar2.jpg';
import Cimes from '../media/cimes.jpg';
import Cimes2 from '../media/cimes2.jpg';
import Zeph from '../media/zeph.jpg';
import Zeph2 from '../media/zeph2.jpg';
import Gaspard from '../media/gaspard.jpg';
import Gaspard2 from '../media/gaspard2.jpg';
import Gogo from '../media/gogo.png';
import Duda from '../media/duda.jpg';
import Duda2 from '../media/duda2.jpg';

import airelleBesson from '../media/airelle-lionel.jpg'
import airelleBesson2 from '../media/airelle-lionel2.jpg'
import airelleBessonMenu from '../media/airelle-besson-menu.png'
import oeuf from '../media/oeuf.png'
import oeuf2 from '../media/oeuf.jpg'
import leon3 from '../media/leon3.png'
import zoe from  '../media/zoe.jpg'
import zoe2 from  '../media/zoe2.jpg'
import lede from  '../media/lede.png'
import lede2 from  '../media/lede2.png'
import jasual from  '../media/jasual.jpg'
import jasual2 from  '../media/jasual2.jpg'
import kaffe from '../media/kaffe.png'
import kaffe2 from '../media/kaffe2.jpg'
import tiab from '../media/tiab.png'
import tiab2 from '../media/tiab2.jpg'
import diaz from '../media/diaz.png'
import diaz2 from '../media/diaz2.jpg'
import eji from '../media/eji.jpg'
import eji2 from '../media/eji2.jpg'
import stambolov from '../media/stambolov.png'
import stambolov2 from '../media/stambolov2.jpg'
import kumbiadelik from '../media/kumbiadelik.png'
import kumbiadelik2 from '../media/kumbiadelik2.jpg'

import photo1 from '../media/photos2022/1.jpg';
import photo2 from '../media/photos2022/2.jpg';
import photo3 from '../media/photos2022/3.jpg';
import photo4 from '../media/photos2022/4.jpg';
import photo5 from '../media/photos2022/5.jpg';
import photo6 from '../media/photos2022/6.jpg';
import photo7 from '../media/photos2022/7.jpg';
import photo8 from '../media/photos2022/8.jpg';
import photo9 from '../media/photos2022/9.jpg';
import photo10 from '../media/photos2022/10.jpg';
import photo11 from '../media/photos2022/11.jpg';
import photo12 from '../media/photos2022/12.jpg';
import photo13 from '../media/photos2022/13.jpg';
import photo14 from '../media/photos2022/14.jpg';
import photo15 from '../media/photos2022/15.jpg';
import photo16 from '../media/photos2022/16.jpg';
import photo17 from '../media/photos2022/17.jpg';
import photo18 from '../media/photos2022/18.jpg';
import photo19 from '../media/photos2022/19.jpg';
import photo20 from '../media/photos2022/20.jpg';


// Edition 2023
import besson_23 from '../media/photos2023/besson.png';
import diaz_23 from '../media/photos2023/diaz.png';
import jasual_23 from '../media/photos2023/jasual.jpg';
import kaffe_23 from '../media/photos2023/kaffe.png';
import kumbiadelik_23 from '../media/photos2023/kumbiadelik.png';
import lede_23 from '../media/photos2023/lede.png';
import oeuf_23 from '../media/photos2023/oeuf.png';
import phal_23 from '../media/photos2023/phal.png';
import stambolov_23 from '../media/photos2023/stambolov.png';
import tiab_23 from '../media/photos2023/tiab.png';
import zoe_23 from '../media/photos2023/zoe.jpg';


// EDITION 2024
import jazzbois1 from '../media/photos2024/jazzbois1.jpg';
import jazzbois2 from '../media/photos2024/jazzbois2.jpg';
import SMSCR1 from '../media/photos2024/SMSCR1.jpg';
import SMSCR2 from '../media/photos2024/SMSCR2.png';
import SMSCR3 from '../media/photos2024/SMSCR3.jpg';
import elliavir1 from '../media/photos2024/elliavir1.jpg';
import elliavir2 from '../media/photos2024/elliavir2.jpg';
import elliavir3 from '../media/photos2024/elliavir3.jpg';
import panam1 from '../media/photos2024/Panam1.png';
import panam2 from '../media/photos2024/Panam2.png';
import clelya1 from '../media/photos2024/Clelya1.jpg';
import clelya2 from '../media/photos2024/Clelya2.jpg';
import afettouche1 from '../media/photos2024/Afettouche1.png';
import shibuuya1 from '../media/photos2024/shibuuya1.jpg';
import shibuuya2 from '../media/photos2024/shibuuya2.jpg';
import pawpaw1 from '../media/photos2024/PawPaw1.jpg';
import zangbeto1 from '../media/photos2024/zangbeto.jpeg';
import bigband1 from '../media/photos2024/bigband1.jpg';
import bigband2 from '../media/photos2024/bigband2.jpg';
import ghost1 from '../media/photos2024/ghost1.jpg';
import ghost2 from '../media/photos2024/ghost2.jpg';




// edition 2025
import WetEnough1 from '../media/photos2025/WetEnough1.jpg';
import WetEnough2 from '../media/photos2025/WetEnough2.jpg';
import WetEnough3 from '../media/photos2025/WetEnough3.jpg';
import LGMX1 from '../media/photos2025/LGMX1.jpg';
import LGMX2 from '../media/photos2025/LGMX2.jpg';
import LGMX3 from '../media/photos2025/LGMX3.jpg';
import Daida1 from '../media/photos2025/Daida1.jpg';
import Daida2 from '../media/photos2025/Daida2.jpg';
import Daida3 from '../media/photos2025/Daida3.jpg';
import Kameni1 from '../media/photos2025/Kameni1.jpg';
import Kameni2 from '../media/photos2025/Kameni2.jpg';
import Kameni3 from '../media/photos2025/Kameni3.jpg';
import Knobil1 from '../media/photos2025/Knobil1.png';
import Knobil2 from '../media/photos2025/Knobil2.jpg';
import Knobil3 from '../media/photos2025/Knobil3.jpg';
import Chicharron1 from '../media/photos2025/CHICHARRON.png';
import Chicharron2 from '../media/photos2025/CHICHARRON2.png';
import Moustik1 from '../media/photos2025/Moustik1.png';
import Moustik2 from '../media/photos2025/Moustik2.png';
import Moustik3 from '../media/photos2025/Moustik3.png';
import imabass0 from '../media/photos2025/imabass0.jpg';
import imabass1 from '../media/photos2025/imabass1.jpeg';
import imabass2 from '../media/photos2025/imabass2.jpeg';
import ima1 from '../media/photos2025/ima1.jpeg';
import menudia1 from '../media/photos2025/menudeldia1.png';
import menudia2 from '../media/photos2025/menudeldia2.png';
import salluste1 from '../media/photos2025/salluste1.png';
import salluste2 from '../media/photos2025/salluste2.png';
import salluste3 from '../media/photos2025/salluste3.png';
import bigband2025_1 from '../media/photos2025/bigband1.png';
import bigband2025_2 from '../media/photos2025/bigband2.jpg';
import anatole0 from '../media/photos2025/anatole0.jpg';
import anatole1 from '../media/photos2025/anatole1.jpg';


// edition 2026
import Migliosi1 from '../media/photos2026/Migliosi1.jpg'
import Migliosi2 from '../media/photos2026/Migliosi2.jpg'
import Migliosi3 from '../media/photos2026/Migliosi3.jpg'
import Menalua1 from '../media/photos2026/Menalua1.jpg'
import Menalua2 from '../media/photos2026/Menalua2.jpg'
import Bathyal1 from '../media/photos2026/Bathyal1.jpg'
import Bathyal2 from '../media/photos2026/Bathyal2.jpg'
import Bathyal3 from '../media/photos2026/Bathyal3.jpg'
import HyperContent1 from '../media/photos2026/HyperContent1.jpg'
import HyperContent2 from '../media/photos2026/HyperContent2.jpg'
import Sarab1 from '../media/photos2026/Sarab1.jpg'
import Sarab2 from '../media/photos2026/Sarab2.jpg'
import Sarab3 from '../media/photos2026/Sarab3.jpg'
import Victoria1 from '../media/photos2026/Victoria1.JPG'
import Victoria2 from '../media/photos2026/Victoria2.jpg'
import Victoria3 from '../media/photos2026/Victoria3.jpg'
import SIB1 from '../media/photos2026/SIB1.jpg'
import SIB2 from '../media/photos2026/SIB2.jpg'
import SIB3 from '../media/photos2026/SIB3.jpg'
import Ludivine1 from '../media/photos2026/Ludivine1.jpg'
import Ludivine2 from '../media/photos2026/Ludivine2.jpg'
import Ludivine3 from '../media/photos2026/Ludivine3.jpg'
import Electrophazz1 from '../media/photos2026/Electrophazz1.png'
import Electrophazz2 from '../media/photos2026/Electrophazz2.png'
import EYM1 from '../media/photos2026/EYM1.jpg'
import EYM2 from '../media/photos2026/EYM2.jpg'
import EYM3 from '../media/photos2026/EYM3.jpg'
import Ascenseur1 from '../media/photos2026/Ascenseur1.jpg'
import Ascenseur2 from '../media/photos2026/Ascenseur2.jpg'
import Mehari1 from '../media/photos2026/Mehari1.jpg'
import Mehari2 from '../media/photos2026/Mehari2.jpg'
import Mehari3 from '../media/photos2026/Mehari3.jpg'



// logos
import villeurbanne from '../media/logo-villeurbanne.png'
import lyon from '../media/logo-lyon.jpg'
import rhinojazz from '../media/logo-rhinojazz.jpg'
import va from '../media/logo-va.png'
import insa from '../media/logo-insa.png'
import helloasso from '../media/logo-helloasso.png'
import crous from '../media/logo-crous.jpg'
import cfc22 from '../media/logo-cfc22.png'
import alumni from '../media/logo-alumni.jpg'
import grandlyon from '../media/logo-grandlyon.png'
import jsmusique from '../media/logo-jsmusique.jpg'
import baguetterie from '../media/logo-baguetterie.jpg'
import ministere from '../media/logo-ministere.png'
import aura from '../media/logo-aura.png'
// import mediatheques from '../media/logo-mediatheques.jpg'
import mediatheques from '../media/logo-mlis.png'
import astree from '../media/logo-astree-2025.jpg'
import rotonde from '../media/logo-rotonde.png'
import peri from '../media/logo-periscope.png'
import toitoi from '../media/logo-toitoi.png'
import kfet from '../media/logo-kfet.png'
import transbo from '../media/logo-transbo.png'
import lyon1 from '../media/logo-lyon1.jpg'

const partenaires=[
    {
        name : "villeurbanne",
        img1: villeurbanne,
        link: ""
    },{
        name : "lyon",
        img1: lyon,
        link: ""
    },{
        name : "rhinojazz",
        img1: rhinojazz,
        link: ""
    },{
        name : "va",
        img1: va,
        link: ""
    },{
        name : "insa",
        img1: insa,
        link: ""
    },{
        name : "helloasso",
        img1: helloasso,
        link: ""
    },{
        name : "crous",
        img1: crous,
        link: ""
    },{
        name : "cfc22",
        img1: cfc22,
        link: ""
    },{
        name : "alumni",
        img1: alumni,
        link: ""
    },{
        name : "grandlyon",
        img1: grandlyon,
        link: ""
    },{
        name : "ministere_*de_la_culture",
        img1: ministere,
        link: ""
    },{
        name : "aura",
        img1: aura,
        link: ""
    },{
        name : "mediatheques",
        img1: mediatheques,
        link: ""
    },{
        name : "astree",
        img1: astree,
        link: ""
    },{
        name : "rotonde",
        img1: rotonde,
        link: ""
    },{
        name : "toitoi",
        img1: toitoi,
        link: ""
    },{
        name : "periscope",
        img1: peri,
        link: ""
    },{
        name : "transbordeur",
        img1: transbo,
        link: ""
    },{
        name : "lyon1",
        img1: lyon1,
        link: ""
    },{
        name : "kfet",
        img1: kfet,
        link: ""
    },{
        name : "jsmusique",
        img1: jsmusique,
        link: ""
    },{
        name : "baguetterie",
        img1: baguetterie,
        link: ""
    }
]


const dataPageArtistesActuels=[
    /*
    {nb:1,
    id: 'zeph',
name : 'ZEPH',
img: Zeph,
day:'13',
month:'oct.'},
{nb:2,
id: 'zeph',
name : 'SupermarchéGoGo',
img: Gogo,
day:'13',
month:'oct.'},
    {nb:6,
    id: 'CSW',
    name: 'Charlier-Sourisse-Winsberg',
    img: CSW2,
    day : '18',
    month : 'oct.',},

    {nb:5,
        id: 'CSW',
        name: 'Jet Whistle',
        img: Jet,
        day : '18',
        month : 'oct.',},

        {nb:3,
        id:'Emile',
        day : '15', 
        month : 'oct.',
        name: "Emile Londonien", //nom affiché
        img : Emile2,
    },

{nb:4,
    id: 'baradel',
img : Gaspard, //image carrée du menu
name : 'Gaspard Baradel',
day : '17',
month : 'oct.'},
    {nb:7,
        id: 'Phal', //adresse url pour affichage
            name: "Léon Phal", //nom affiché
            img : Phal, //image carrée du menu
            day : '19', 
            month : 'oct.',
    },
        
    {nb:9,
        id: 'oscar',
    img : Oscar, //image carrée du menu
    name : 'Oscar Jerome',
    day : '20',
    month : 'oct.'},
{nb:8,
id: 'oscar',
name: 'Gin Tonic Orchestra',

day : '20',
month : 'oct.',
img:GTO},
        
{nb:10,
    id: 'duda',
img : Duda2, //image carrée du menu
name : 'Joanna Duda',
day : '21',
month : 'oct.'},
*/
]

const salles_url = {
    rotonde: "https://rotonde.asso-insa-lyon.fr/",
    transbordeur: "https://www.transbordeur.fr/",
    astree: "https://theatre-astree.univ-lyon1.fr/",
    toitoi: "https://www.toitoilezinc.fr/infos-pratiques/",
    periscope: "https://www.periscope-lyon.com/",
    mlis: "https://mediatheques.villeurbanne.fr/sujet/infos-pratiques/",
    kfet: "https://app.kfet-insa.fr/home"
};


const data=[
    {
        nb : 1, //numéro de repérage pour affichage
        id: 'Menalua_url', //adresse url pour affichage
        name: "Menalua", //nom affiché
        quote : <p id="quoteConcert">En naviguant entre jazz moderne, influences latines et chanson intimiste, MENALUA trace un sillon singulier dans le paysage actuel du jazz français. Ce groupe, récompensé à Vannes (1er prix du Tremplin National Vannes Echos Jazz 2024) puis à Crest (1er prix du concours de jazz vocal de Crest Jazz 2025), surprend par sa “capacité à visiter des territoires fort complexes, tout en pouvant se révéler au contraire plus accessible” (P-A Jonard, Longueur d’Ondes). La conversation entre ses membres, constante et à géométrie variable, offre une véritable poésie de l’instant. 
            <br/><br/>Contraction de “Menina da Lua” (Fille de la Lune en portugais et clin d’œil à la sublime chanson de Renato Motha), MENALUA fait à la fois écho à une forme d’onirisme ainsi qu’aux musiques brésiliennes qui ont profondément marqué les musicien.ne.s du groupe dans leur construction d’artistes. Cette musique métissée se met au service de textes écrits aussi bien en langue française ou anglaise, à découvrir dans l’album “Premier Printemps”, sorti le 6 juin 2025. </p>,
        //premier texte
        desc : <p id="quoteConcert">
            Line-up : <br/>
            - Mathilde GARDIEN - Voix, piano, synthé, composition <br/>
            - Romain SALMON - Guitares, composition <br/>
            - Matis REGNAULT - Contrebasse <br/>
            - Basile GUEGUEN - Batterie<br/><br/>
            Crédits photos : Julia Salmon</p>,
        desc2 : '',
        //deuxième texte
        img1 : Menalua2, //image header
        img2 : Menalua1, //image milieu de texte
        imgMenu : Menalua1,
        day : '6', 
        month : 'oct.',
        year : '2026',
        hour : '20h30', //la date précise du concert
        place : "La Rotonde",//l'endroit du concert
        placeIndications : salles_url.rotonde,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '9€',
        nomTarif2 : "Tarif réduit étudiant.e - PMR/PSH - Demandeur.se d'emploi - Retraité.e : ",
        tarif2 : '5€',
        nomTarif3 : 'Carte VA (INSA): ',
        tarif3 : '3€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-la-rotonde',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 2, //numéro de repérage pour affichage
        id: 'Bathyal_url', //adresse url pour affichage
        name: "Bathyal", //nom affiché
        quote : <p id="quoteConcert">Créé par Maëva Da Justina, Bathyal Ensemble réunit sept musicien.ne.s, dont quatre vocalistes et une section rythmique. 
        <br/><br/>La musique de ce groupe s'articule autour de la polyphonie vocale, et d'un dialogue constant avec les instruments.  
        <br/>Le projet tire son nom de la zone océanique bathyale : cet espace à l'intersection de la lumière et de l'obscurité. De cette dualité s'est définie l'identité du groupe, mêlant jazz et sonorités actuelles. 
        <br/><br/>À travers des arrangements mélodieux, l'improvisation collective, et des textes engagés, les compositions de Maëva explorent la condition humaine, et notre lien à la nature. Une invitation à plonger dans un univers hybride et poétique.
        </p>,
        //premier texte
        desc : <p id="quoteConcert">
            Line-up : <br/>
            - Maëva DA JUSTINA - Voix lead<br/>
            - Manon CHAUVIÈRE - Voix mezzo-soprane<br/>
            - Luce BONZON - Voix alto<br/>
            - Pierre SEROUX - Voix basse<br/>
            - Lucie MARIEN - Piano / Clavier <br/>
            - Antoine FONTANEL - Contrebasse<br/>
            - Gaëtan LONGUENESSE - Batterie<br/>
            </p>,
        desc2 : '',
        //deuxième texte
        img1 : Bathyal2, //image header
        img2 : Bathyal3, //image milieu de texte
        imgMenu : Bathyal1,
        day : '6', 
        month : 'oct.',
        year : '2026',
        hour : '20h30', //la date précise du concert
        place : "La Rotonde",//l'endroit du concert
        placeIndications : salles_url.rotonde,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '9€',
        nomTarif2 : "Tarif réduit étudiant.e - PMR/PSH - Demandeur.se d'emploi - Retraité.e : ",
        tarif2 : '5€',
        nomTarif3 : 'Carte VA (INSA): ',
        tarif3 : '3€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-la-rotonde',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 3, //numéro de repérage pour affichage
        id: 'HyperContent_url', //adresse url pour affichage
        name: "HyperContent!", //nom affiché
        quote : <p id="quoteConcert">HYPERCONTENT! c’est un collectif francochilien-belge basé à Bruxelles, porté par une énergie brute, un amour du groove et deux batteurs qui mènent la danse : Raphaël Aurand et Elie Gouleme. 
        <br/><br/>À sept sur scène, ils mélangent les rythmiques percutantes de la house, les textures de l’électro et la chaleur du funk et du groove pour faire bouger les corps et brouiller les frontières entre scène et dancefloor. On pense à Kerri Chandler, à Ezra Collective, mais surtout à un son bien à eux : organique, libre et terriblement vivant </p>,
        //premier texte
        desc : <p id="quoteConcert">
            Line-up : <br/>
            - Maxime DEREUX - Saxophone  <br/>
            - Marius RABBE - Trombone <br/>
            - Thomas SAGNE - Guitare <br/>
            - Tomas GARCIA RIVERA - Claviers<br/>
            - Yannick HESELLE - Basse<br/>
            - Raphaël AURAND et Elie GOULEME - Batteries <br/><br/>
            Crédits photos : ©Jérôme Duikers</p>,
        desc2 : '',
        //deuxième texte
        img1 : HyperContent2, //image header
        img2 : HyperContent1, //image milieu de texte
        imgMenu : HyperContent1,
        day : '7', 
        month : 'oct.',
        year : '2026',
        hour : '20h30', //la date précise du concert
        place : "Toï Toï Le Zinc",//l'endroit du concert
        placeIndications : salles_url.toitoi,
        nomTarif1 : 'Tarif solidaire, budget épanoui: ', //tous les tarifs (3 maximum pour l'instant)
        tarif1: '15€',
        nomTarif2 : "Tarif solidaire, budget moyen : ",
        tarif2 : '12€',
        nomTarif3 : 'Tarif Mini : ',
        tarif3 : '9€',
        nomTarif4 : 'Tarif étudiant VA INSA/étudiants ENM ou CRR :',
        tarif4 : '7€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-toi-toi',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },
 
    {
        nb : 4, //numéro de repérage pour affichage
        id: 'Sarab_url', //adresse url pour affichage
        name: "Sarãb", //nom affiché
        quote : <p id="quoteConcert">Porté par la chanteuse franco-syrienne Climène Zarkan et le guitariste Baptiste Ferrandis, legroupe Sarāb trace une route entre chaos post-punk et poésie arabe. Après deux albums (Sarāb, sorti en 2019 et Arwāh Hurra, en 2022) et un EP (Qawalebese Tape, sorti en 2023) aux influences jazz et global music ancrées dans la richesse des patrimoines musicaux du Proche-Orient, le quintet est revenu début 2026 avec un nouveau disque ravageur, MītWarde - Cent roses.  
        <br/><br/>À l’oreille : une odyssée sonore viscérale, où déferlantes de rock pur et sonorités techno côtoient des textes engagés, hommages acoustiques et intimes aux victimes de la guerre. Sur scène : une énergie brute, une voix incantatoire, des maqâmât, des synthés analogiques et des rythmes qui frisent la rupture. Après plus de 100 concerts en Europe, au Canada et au Maroc, Sarāb (« mirage » en arabe) assume son virage rock tout en conservant une identité hybride, quelque part entre l’autotune de Rosalía, et les riffs militants de Rage Against TheMachine. 
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Climène ZARKAN – Chant <br/>
        - Baptiste FERRANDIS – Guitare <br/>  
        - Thibault GOMEZ - Claviers, piano <br/>
        - Timothée ROBERT – Basse <br/>
        - Paul BERNE - Batterie <br/><br/>
        Crédits photos : ©Sylvain Gripoix</p>,
        desc2 : '',
        //deuxième texte
        img1 : Sarab2, //image header
        img2 : Sarab3, //image milieu de texte
        imgMenu : Sarab1,
        day : '7', 
        month : 'oct.',
        year : '2026',
        hour : '20h30', //la date précise du concert
        place : "Toï Toï Le Zinc",//l'endroit du concert
        placeIndications : salles_url.toitoi,
        nomTarif1 : 'Tarif solidaire, budget épanoui: ', //tous les tarifs (3 maximum pour l'instant)
        tarif1: '15€',
        nomTarif2 : "Tarif solidaire, budget moyen : ",
        tarif2 : '12€',
        nomTarif3 : 'Tarif Mini : ',
        tarif3 : '9€',
        nomTarif4 : 'Tarif étudiant VA INSA/étudiants ENM ou CRR :',
        tarif4 : '7€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-toi-toi',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 5, //numéro de repérage pour affichage
        id: 'ProjectionMLIS_url', //adresse url pour affichage
        name: "Ascenseur pour l'échafaud", //nom affiché
        quote : <p id="quoteConcert">L'anniversaire des cent ans de Miles Davis offre l'occasion de se pencher sur la contribution du jazzman au septième art à travers l'enregistrement mythique, dans la nuit du 4 au 5 décembre 1957, de la bande originale du film de Louis Malle, Ascenseur pour l'échafaud.<br/><br/>
        Cette adaptation d'un roman policier de Noël Calef est le premier long métrage de fiction de Louis Malle qui a alors 25 ans. Deux amants diaboliques joués par Jeanne Moreau et Maurice Ronet, l'atmosphère des nuits parisiennes au cœur des années 50, un meurtre, un ascenseur en panne et bien sur la musique de Miles Davies tissent l'intrigue de ce film noir. <br/><br/>Grand succès à sa sortie, il reçoit le Lion d'or à Venise, le prix Louis-Delluc et sept Césars, dont ceux du meilleur film et du meilleur réalisateur.
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Centenaire Miles Davis<br/><br/>
        Image : Nouvelles Éditions de Films, Gaumont, 1958</p>,
        desc2 : '',
        //deuxième texte
        img1 : Ascenseur2, //image header
        img2 : Ascenseur1, //image milieu de texte
        imgMenu : Ascenseur1,
        day : '8', 
        month : 'oct.',
        year : '2026',
        hour : '19h', //la date précise du concert
        place : "MLIS",//l'endroit du concert
        placeIndications : salles_url.mlis,
        nomTarif1 : 'Gratuit sans réservation, entrée libre', //tous les tarifs (3 maximum pour l'instant)
        tarif1: '',
        nomTarif2 : "",
        tarif2 : '',
        nomTarif3 : '',
        tarif3 : '',
        nomTarif4 : '',
        tarif4 : '',
        billeterie : '',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 6, //numéro de repérage pour affichage
        id: 'HermonMehariTrio_url', //adresse url pour affichage
        name: "Hermon Mehari Trio", //nom affiché
        quote : <p id="quoteConcert">Le trompettiste de jazz américain Hermon Mehari fait halte à la Maison du livre, de l'image et du son pour jouer, avec son trio, un concert hommage à Miles Davis, musicien incontournable du XXe siècle. Hard bop, jazz modal, west coast, free ou fusion ; une explosion de créativité et de génie dont on fête les cent ans cette année. <br/><br/>Hermon Mehari est un trompettiste et compositeur primé dont la musique reflète une identité artistique aux multiples facettes : l'héritage jazz de sa ville natale de Kansas City, ses nombreuses collaborations avec des artistes de tous horizons et un lien profond avec ses racines. <br/><br/>Reconnu pour sa sonorité lyrique, son audace et son langage musical ouvert, Mehari mène une carrière entre l'Europe et les États-Unis. Auteur de plus de sept albums studio et membre fondateur du groupe Diverse, il enchaîne aujourd'hui les tournées à travers le monde en tant que leader ou comme collaborateur très sollicité (Jaleel Shaw, Tony Tixier, Dave Pietro, etc.) 
        </p>,
        //premier texte
        desc : <p id="quoteConcert"></p>,
        desc2 : '',
        //deuxième texte
        img1 : Mehari2, //image header
        img2 : Mehari3, //image milieu de texte
        imgMenu : Mehari1,
        day : '9', 
        month : 'oct.',
        year : '2026',
        hour : '19h', //la date précise du concert
        place : "MLIS",//l'endroit du concert
        placeIndications : salles_url.mlis,
        nomTarif1 : 'Gratuit sans réservation, entrée libre', //tous les tarifs (3 maximum pour l'instant)
        tarif1: '',
        nomTarif2 : "",
        tarif2 : '',
        nomTarif3 : '',
        tarif3 : '',
        nomTarif4 : '',
        tarif4 : '',
        billeterie : '',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 7, //numéro de repérage pour affichage
        id: 'Victoria_url', //adresse url pour affichage
        name: "Victoria Alexanyan", //nom affiché
        quote : <p id="quoteConcert">Lorsque Victoria Alexanyan a décidé de quitter son Arménie natale pour s’installer en France, elle n’imaginait pas que ce serait un révélateur si puissant de la culture ancestrale qui l’habitait.  
        <br/><br/>À travers sa musique, elle n’évoque pas seulement l’histoire tourmentée de l’Arménie, transformant la colère en poésie ; mais également son rapport sensible au monde, épris de liberté et d’universalité. Lauréate du Golden Jazz Trophy 2026 (Prix du jury), ses compositions, à la fois intérieures et politiques, sont marquées d’une révolte profonde contre l’injustice qu’elle déclame avec une délicatesse particulière.  
        <br/><br/>Dans son premier album en quintet, VISHAP (dragon en arménien), elle réveille cette créature mythique et ambiguë qui hante l’imaginaire arménien. Enfoui sous les rochers et les lacs, il est porteur d’une mémoire ancienne et immuable. VISHAP devient alors un chant, une incantation portée par les vents des montagnes arméniennes. La musique serpente entre mystère et éclats, imprégnée d’une énergie féminine et rebelle. Métriques complexes, improvisations et influences modales s’entrelacent, donnant naissance à un univers sonore indomptable, à l’image du dragon. 
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Victoria ALEXANYAN - Voix, composition<br/>
        - Amin AL AIEDY - Oud, nay, co-composition <br/>
        - Vincent FORESTIER - Piano, co-composition<br/>
        - Yann PHAYPHET - Contrebasse<br/>
        - Matheo CIESLA - Batterie, chœur<br/><br/>
        Crédits photo de groupe (accueil) : © Mikel Muneton <br/>
        Crédits deux autres photos : © Anne- Laure Étienne  </p>,
        desc2 : '',
        //deuxième texte
        img1 : Victoria2, //image header
        img2 : Victoria3, //image milieu de texte
        imgMenu : Victoria1,
        day : '13', 
        month : 'oct.',
        year : '2026',
        hour : '21h', //la date précise du concert
        place : "Le Périscope",//l'endroit du concert
        placeIndications : salles_url.periscope,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '15€',
        nomTarif2 : "Tarif réduit - Carte Lyon Culture : ",
        tarif2 : '11€',
        nomTarif3 : 'Abonné Périscope - Carte VA (INSA) : ',
        tarif3 : '8€',
        billeterie : 'https://billetterie.periscope-lyon.com/agenda/1321-Victoria-Alexanyan-Quintet-Sampling-is-Beautiful',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 8, //numéro de repérage pour affichage
        id: 'SamplingIsBeautiful_url', //adresse url pour affichage
        name: "Sampling Is Beautiful", //nom affiché
        quote : <p id="quoteConcert">Sampling Is Beautiful Trio est un groupe formé en 2022 qui propose une fusion originale entre jazz, hip-hop, funk et musique électronique, avec une place centrale accordée au sampling en direct. Le trio est composé de Zajazza (sampleurs, scratch, clavier), Yacha Berdah (trompette, basse, looper) et Japhet Boristhène (batterie, rap), trois musiciens issus d’univers variés et ayant collaboré avec des artistes comme Ibrahim Maalouf, Gaël Faye, Chassol, Grand Corps Malade ou encore Saïan Supa Crew. 
        <br/><br/>Sur scène, le groupe crée une musique en constante évolution en mélangeant instruments jazz traditionnels, beatmaking, scratches, voix et samples de morceaux anciens ou oubliés. Cette approche interactive donne naissance à un univers sonore à la fois nostalgique, moderne et très dynamique.
        <br/><br/>Le trio s’est notamment produit au Jazz à Vienne, aux Nancy Jazz Pulsations, au Sunnyside Festival de Reims, à Jazz à Val Thorens ou encore au Superspectives Festival. Il a également joué en première partie de Vulfpeck et participé à l’émission Improbox aux côtés d’Ibrahim Maalouf.
        <br/><br/>Leur album Capture illustre cette identité musicale en mêlant compositions originales, jazz, hip-hop et sampling, avec la participation de plusieurs chanteurs et musiciens invités. À travers ce projet, Sampling Is Beautiful Trio cherche à repousser les frontières entre les genres et les époques, en transformant le sampling en véritable instrument de création et de performance live.  
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Clément SERGÉ aka Zajazza - Sampleurs, scratch, clavier<br/>
        - Yacha BERDAH - Trompette, basse, looper<br/>
        - Japhet BORISTHÈNE - Batterie, rap<br/>
        <br/>Crédits photo de groupe : Paul Bourdrel </p>,
        desc2 : '',
        //deuxième texte
        img1 : SIB2, //image header
        img2 : SIB3, //image milieu de texte
        imgMenu : SIB1,
        day : '13', 
        month : 'oct.',
        year : '2026',
        hour : '21h', //la date précise du concert
        place : "Le Périscope",//l'endroit du concert
        placeIndications : salles_url.periscope,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '15€',
        nomTarif2 : "Tarif réduit - Carte Lyon Culture : ",
        tarif2 : '11€',
        nomTarif3 : 'Abonné Périscope - Carte VA (INSA) : ',
        tarif3 : '8€',
        billeterie : 'https://billetterie.periscope-lyon.com/agenda/1321-Victoria-Alexanyan-Quintet-Sampling-is-Beautiful',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 9, //numéro de repérage pour affichage
        id: 'Migliosi_url', //adresse url pour affichage
        name: "Daniel Migliosi", //nom affiché
        quote : <p id="quoteConcert">Daniel Migliosi est l’un des talents les plus prometteurs et les plus importants de la scène jazz européenne contemporaine. Avec son quartet, il repousse les limites de la musique, en puisant son inspiration chez leurs héros tout en mêlant influences modernes et touche personnelle. 
        <br/><br/>Venus de différents horizons musicaux, chacun des membres du Daniel Migliosi Quartet apporte ses propres influences et perspectives. Cette diversité crée un échange riche et stimulant au sein du groupe, façonnant un son à la fois novateur et profondément ancré dans la tradition. 
        <br/><br/>Le quartet est animé par un amour profond pour la musique et par le désir créatif de contribuer à l’évolution du paysage musical actuel. Ils sont convaincus qu’une bonne musique fera toujours entendre sa voix - qu’elle soit complexe ou simple, l’essentiel étant son honnêteté et sa qualité. 
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Daniel MIGLIOSI - Trompette  <br/>
        - Levi HARVEY - Piano<br/>  
        - Antoine LEONARDON - Basse<br/>
        - Kai CRAIG - Percussions</p>,
        desc2 : '',
        //deuxième texte
        img1 : Migliosi2, //image header
        img2 : Migliosi3, //image milieu de texte
        imgMenu : Migliosi1,
        day : '15', 
        month : 'oct.',
        year : '2026',
        hour : '20h20', //la date précise du concert
        place : "Théâtre Astrée",//l'endroit du concert
        placeIndications : salles_url.astree,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '15€',
        nomTarif2 : "Tarif réduit étudiant.e - PMR/PSH - Demandeur.se d'emploi - Retraité.e - élève ENM ou CRR: ",
        tarif2 : '10€',
        nomTarif3 : 'Carte VA (INSA) - Personnel Lyon 1 : ',
        tarif3 : '6€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-astree',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 10, //numéro de repérage pour affichage
        id: 'EYMTrio_url', //adresse url pour affichage
        name: "EYM Trio", //nom affiché
        quote : <p id="quoteConcert">EYM Trio est un trio lyonnais fondé en 2011 par le pianiste Elie Dufour, le contrebassiste Yann Phayphet et le batteur Marc Michel. Avec plus de 400 concerts dans une vingtaine de pays, le groupe développe un jazz ouvert, nourri par les musiques du monde et les rencontres faites au fil de ses tournées. 
        <br/><br/>Au fil de ses albums, EYM Trio collabore avec des artistes internationaux comme Mohamed Abozekry, Marian Badoï, Mirande Shah, Gilad Hekselman ou Varijashree Venugopal, intégrant des influences égyptiennes, tziganes, indiennes ou orientales à son univers. 
        <br/><br/>En 2019, le trio lance Nomad’ Sessions, une web-série autoproduite enregistrée dans des lieux atypiques à travers le monde. 
        <br/><br/>Avec Casablanca, sorti en 2024, EYM Trio revient à une création entièrement à trois. L’album reflète l’état d’esprit nomade du groupe et propose un jazz mélodique qui se joue des frontières, avec notamment des influences bulgares, tziganes et orientales. Une innovation pianistique permet également à Elie Dufour d’obtenir des sonorités inédites, proches du oud et des instruments à cordes pincées. 
        <br/><br/>Casablanca se présente ainsi comme un véritable voyage sonore, dans la continuité de l’identité nomade construite par le trio depuis ses débuts. 
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Elie DUFOUR - Piano<br/>
        - Yann PHAYPHET - Contrebasse<br/>  
        - Marc MICHEL - Batterie <br/><br/>
        Crédits photo : © Eric Meurice</p>,
        desc2 : '',
        //deuxième texte
        img1 : EYM2, //image header
        img2 : EYM3, //image milieu de texte
        imgMenu : EYM1,
        day : '15', 
        month : 'oct.',
        year : '2026',
        hour : '20h20', //la date précise du concert
        place : "Théâtre Astrée",//l'endroit du concert
        placeIndications : salles_url.astree,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '15€',
        nomTarif2 : "Tarif réduit étudiant.e - PMR/PSH - Demandeur.se d'emploi - Retraité.e - élève ENM ou CRR: ",
        tarif2 : '10€',
        nomTarif3 : 'Carte VA (INSA) - Personnel Lyon 1 : ',
        tarif3 : '6€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-astree',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 11, //numéro de repérage pour affichage
        id: 'LudivineIssambourg_url', //adresse url pour affichage
        name: "Ludivine Issambourg", //nom affiché
        quote : <p id="quoteConcert">Ludivine Issambourg est une flûtiste, compositrice et productrice française reconnue depuis près de 15 ans. Formée à la fois au classique et au jazz, elle développe très tôt une grande maîtrise de la flûte et de l’improvisation. 
        <br/><br/>Elle se fait connaître en 2007 lorsqu’elle rejoint Wax Tailor, avec qui elle parcourt le monde pendant cinq ans. Elle collabore ensuite avec de nombreux artistes prestigieux comme Eric Legnini, Chassol, Nils Landgren, Cut Killer, Incognito, Catherine Ringer ou encore Angélique Kidjo. 
        <br/><br/>En 2012, elle crée ANTILOOPS, un groupe mêlant jazz, funk, électro et hip-hop, avec lequel elle sort plusieurs albums et se produit dans de nombreux festivals. 
        <br/><br/>En parallèle, elle développe le projet OUTLAWS, consacré notamment au célèbre flûtiste américain Hubert Laws. Après l’album Outlaws en 2020, elle poursuit cet hommage avec Above The Laws, sorti chez Heavenly Sweetness, en mélangeant compositions originales et reprises inspirées par plusieurs grandes figures du jazz, du funk et de la soul. 
        <br/><br/>Son parcours est marqué par une volonté constante de mélanger les styles et de faire de la flûte un instrument central du jazz contemporain. Avec plus de 500 000 streams pour Supernova en 2022 et de nombreuses collaborations internationales, Ludivine Issambourg s’impose comme l’une des figures importantes de la flûte jazz en France. 
        </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Ludivine ISSAMBOURG - Flûte traversière<br/>
        - Eric LEGNINI - Direction artistique, réalisation<br/>  
        - Laurent COULONDRE - Claviers<br/>
        - Julien HERNE - Basse<br/>
        - Stéphane Huchard - Batterie<br/><br/>
        Crédits photo : MarOne </p>,
        desc2 : '',
        //deuxième texte
        img1 : Ludivine2, //image header
        img2 : Ludivine3, //image milieu de texte
        imgMenu : Ludivine1,
        day : '16', 
        month : 'oct.',
        year : '2026',
        hour : '19h', //la date précise du concert 
        place : "Le Transbordeur - Club Transbo",//l'endroit du concert
        placeIndications : salles_url.transbordeur,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '20€', 
        nomTarif2 : "Tarif réduit : ",
        tarif2 : '15€',
        nomTarif3 : 'Carte VA (INSA) - Code promo : ',
        tarif3 : '13€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-transbordeur',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    },

    {
        nb : 12, //numéro de repérage pour affichage
        id: 'Electrophazz_url', //adresse url pour affichage
        name: "Eletrophazz", //nom affiché
        quote : <p id="quoteConcert">Le groupe Electrophazz est de retour avec son nouvel opus « Back to the future ». Après 15 ans de présence sur les scènes Jazz, Rnb et Hip-Hop françaises et internationales, ces Groovers reviennent aux sources de ce qui a créé leur style, tout en mêlant leurs racines à un son plus moderne. 
        <br/>Un mélange explosif qui donne lieu à un show unique dans lequel on se laisse happer par l'énergie de Mickaëlle Leslie, chanteuse charismatique (demi-finaliste de The Voice 2026) donnant le change à Eneeks, rappeur Londonien au flow pénétrant. Le tout porté par une section rythmique décoiffante et un sax électrisant l'ensemble. Un show positif qui célèbre la Musique et le Live dans leurs multiples facettes. </p>,
        //premier texte
        desc : <p id="quoteConcert">Line Up : <br/>
        - Mickaëlle LESLY - Chant <br/>
        - ENEEKS - MC<br/>
        - Jean-Alain BOISSY - Saxophone Tenor / Mikrokorg<br/>
        - David MARION - Clavier<br/>
        - Ylucas BENEDETTI - Basse<br/>  
        - Japhet BORISTHENE - Batterie</p>,
        desc2 : '',
        //deuxième texte
        img1 : Electrophazz2, //image header
        img2 : Electrophazz1, //image milieu de texte
        imgMenu : Electrophazz1,
        day : '16', 
        month : 'oct.',
        year : '2026',
        hour : '19h', //la date précise du concert 
        place : "Le Transbordeur - Club Transbo",//l'endroit du concert
        placeIndications : salles_url.transbordeur,
        nomTarif1 : 'Tarif plein : ', //tous les tarifs (3 maximum pour l'instant)
        tarif1 : '20€', 
        nomTarif2 : "Tarif réduit :",
        tarif2 : '15€',
        nomTarif3 : 'Carte VA (INSA) - Code promo : ',
        tarif3 : '13€',
        billeterie : 'https://www.helloasso.com/associations/association-festival-un-doua-de-jazz/evenements/concert-un-doua-de-jazz-x-transbordeur',
        duo : false, //TRUE si concert en 2 parties, false sinon  
        // gratuit : true,
        reservable : true,
        disponibiliteTarifs : true,
    }
]



const dataAnc=[
    {nb : 49,
        id: 'LGMX', 
        name: "LGMX",
        img1 : LGMX2,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 48,
        id: 'Daïda', 
        name: "Daïda",
        img1 : Daida1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 47,
        id: 'IMA:R', 
        name: "IMA:R",
        img1 : ima1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 46,
        id: 'Wet Enough !?', 
        name: "Wet Enough !?",
        img1 : WetEnough1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 45,
        id: 'Moustik Haterz', 
        name: "Moustik Haterz",
        img1 : Moustik1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 44,
        id: 'Chicharron', 
        name: "Chicharron",
        img1 : Chicharron1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 43,
        id: 'Menu Del Dia Trio', 
        name: "Menu Del Dia Trio",
        img1 : menudia1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 42,
        id: 'Don Salluste', 
        name: "Don Salluste",
        img1 : salluste1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 41,
        id: 'Big_Band_INSA', 
        name: "Big Band de l'INSA",
        img1 : bigband2025_1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 40,
        id: 'Louise Knobil', 
        name: "Louise Knobil",
        img1 : Knobil1,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 39,
        id: 'Anatole', 
        name: "Anatole",
        img1 : anatole0,
        year: '2025',
        edition : '32',
        duo : false,    
    },
    {nb : 38,
        id: 'Celia Kameni', 
        name: "Celia Kameni",
        img1 : Kameni1,
        year: '2025',
        edition : '32',
        duo : false,    
    },


    {nb : 37,
        id: 'Big_Band_INSA', 
        name: "Big Band de l'INSA",
        img1 : bigband1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 36,
        id: 'Ghost Jazz Project', 
        name: "Ghost Jazz Project",
        img1 : ghost1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 35,
        id: 'Clelya Abraham 4tet', 
        name: "Clelya Abraham 4tet",
        img1 : clelya1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 34,
        id: 'Shibuuya', 
        name: "Shibuuya",
        img1 : shibuuya1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 33,
        id: 'Zangbeto', 
        name: "Zangbeto",
        img1 : zangbeto1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 32,
        id: 'PawPaw', 
        name: "PawPaw",
        img1 : pawpaw1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 31,
        id: 'AfettoucheTetralyre', 
        name: "LéoHugo Afettouche & Tetralyren",
        img1 : afettouche1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 30,
        id: 'Panam_Panic', 
        name: "Panam Panic",
        img1 : panam1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 29,
        id: 'ElliAVir_url', 
        name: "ElliAVir",
        img1 : elliavir1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 28,
        id: 'SMSCR_url', 
        name: "SuperMegaSuperCool Révolution",
        img1 : SMSCR1,
        year: '2024',
        edition : '31',
        duo : false,    
    },
    {nb : 27,
        id: 'jazzbois_url', 
        name: "Jazzbois",
        img1 : jazzbois1,
        year: '2024',
        edition : '31',
        duo : false,    
    },



    {nb : 26,
        id: 'Phal', 
        name: "Léon Phal",
        img1 : phal_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 25,
        id: 'Lede', 
        name: "Ledé Markson",
        img1 : lede_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 24,
        id: 'Jasual', 
        name: "Jasual Cazz",
        img1 : jasual_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 23,
        id: 'Zoe', 
        name: "Zoe's Shanghai",
        img1 : zoe_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 22,
        id: 'Tiab', 
        name: "Célia Tiab",
        img1 : tiab_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 21,
        id: 'Diaz', 
        name: "Hugo Diaz Quartet",
        img1 : diaz_23,
        year: '2023',
        edition : '30',
        duo : false,    
        },

    {nb : 20,
        id: 'Besson', 
        name: "Airelle Besson et Lionel Suarez",
        img1 : besson_23,
        year: '2023',
        edition : '30',
        duo : false,    
    },
        
    {nb : 19,
        id: 'Oeuf', 
        name: "Big Band de l'Oeuf",
        img1 : oeuf_23,
        year: '2023',
        edition : '30',
        duo : false,    
    },

    {nb : 18,
        id: 'Stambolov', 
        name: "Captain Stambolov",
        img1 : stambolov_23,
        year: '2023',
        edition : '30',
        duo : false,    
    },

    {nb : 17,
        id: 'Kumbiadelik', 
        name: "Kumbiadelik",
        img1 : kumbiadelik_23,
        year: '2023',
        edition : '30',
        duo : false,    
    },

    {nb : 16,
        id: 'Kaffe', 
        name: "Kaffe Krème",
        img1 : kaffe_23,
        year: '2023',
        edition : '30',
        duo : false,    
    },
          
    {nb: 15,
        id: 'oscar',
        img1 : Oscar, //image carrée du menu
        name : 'Oscar Jerome',
        year : '2022',
        edition : '29',
        duo : false
    },

    {nb : 14,
        id: 'Phal', //adresse url pour affichage
        name: "Léon Phal", //nom affiché
        img1 : Phal, //image carrée du menu
        year:'2022',
        edition  : '29',
        duo : false
    },

    {nb : 13,
        id:'Emile',
        year : '2022', 
        edition : '29',
        name: "Emile Londonien", //nom affiché
        img1 : Emile2,
        duo : false
    },

    {nb : 12,
        id: 'CSW',
        name: 'Charlier-Sourisse-Winsberg',
        img1: CSW2,
        year : '2022',
        edition : '29',
        duo:false
    },

    {nb : 11,
        id: 'bertaut', 
        name: "Camille Bertaut",
        img1 : bertaut,
        year: '2021',
        edition : '28',
        duo : false,    
    },

    {nb : 10,
        id: 'yellowstraps', 
        name: "Yellowstraps",
        img1 : yellowstraps,
        year: '2019',
        edition : '26',
        duo : false,    
    },

    {nb : 9,
        id: 'garcia', 
        name: "Nubya Garcia",
        img1 : garcia,
        year: '2019',
        edition : '26',
        duo : false,    
    },

    {nb : 8,
        id: 'dooz', 
        name: "Dooz Kawa",
        img1 : dooz,
        year: '2018',
        edition : '25',
        duo : false,    
    },

    {nb : 7,
        id: 'anomalie', 
        name: "Anomalie",
        img1 : anomalie,
        year: '2018',
        edition : '25',
        duo : false,    
    },

    {nb : 6,
        id: 'glyk', 
        name: "Kinga Glyk",
        img1 : glyk,
        year: '2018',
        edition : '25',
        duo : false,    
    },

    {nb : 5,
        id: 'foehn', 
        name: "Foehn Trio",
        img1 : foehn,
        year: '2016',
        edition : '23',
        duo : false,    
    },

    {nb : 4,
        id: 'henry', 
        name: "Cory Henry",
        img1 : henry,
        year: '2015',
        edition : '22',
        duo : false,    
    },

    {nb : 3,
        id: 'glasper', 
        name: "Robert Glasper",
        img1 : glasper,
        year: '2014',
        edition : '21',
        duo : false,    
    },
 
    {nb : 2,
        id: 'tigran', 
        name: "Tigran Hamasyan",
        img1 : tigran,
        year: '2009',
        edition : '16',
        duo : false,    
    },

    {nb : 1,
        id: 'potter', 
        name: "Chris Potter",
        img1 : chris,
        year: '2003',
        edition : '10',
        duo : false,    
    },
   
]

const photos=[{
    img:photo1,
    name:"Gaspard Baradel 4tet"
},{
    img:photo2,
    name:"Gaspard Baradel 4tet"
},{
    img:photo3,
    name:"Gaspard Baradel 4tet"
},{
    img:photo4,
    name:"Gaspard Baradel 4tet"
},{
    img:photo5,
    name:"Zeph"
},{
    img:photo6,
    name:"Supermarché Gogo"
},{
    img:photo7,
    name:"Gin Tonic Orchestra"
},{
    img:photo8,
    name:"Oscar Jerome"
},{
    img:photo9,
    name:"Oscar Jerome"
},{
    img:photo10,
    name:"Oscar Jerome"
},{
    img:photo11,
    name:"Association Musicale de L'INSA"
},{
    img:photo12,
    name:"Zeph"
},{
    img:photo13,
    name:"Zeph"
},{
    img:photo14,
    name:"Gin Tonic Orchestra"
},{
    img:photo15,
    name:"Léon Phal"
},{
    img:photo16,
    name:"Léon Phal"
},{
    img:photo17,
    name:"Léon Phal"
},{
    img:photo18,
    name:"Trio Charlier Sourisse Winsberg"
},{
    img:photo19,
    name:"Trio Charlier Sourisse Winsberg"
},{
    img:photo20,
    name:"Trio Charlier Sourisse Winsberg"
}]

function photosNb(number){
    return photos[number];
}

function photosSize(){
    return photos.length;
}

function donnees(string){
    return data.find(el => el.id===string);
    
}

function donneesNb(number){
    return data.find(el => el.nb===number);
    
}


function donneesPageArtistesActuels(string){
    return dataPageArtistesActuels.find(el => el.id===string);
    
}

function donneesPageArtistesActuelsNb(number){
    return dataPageArtistesActuels.find(el => el.nb===number);
    
}

function donneesAnciennes(string){
    return dataAnc.find(el => el.id===string);
}

function donneesAnciennesNb(number){
    return dataAnc.find(el => el.nb===number);
}

function partenaire(string){
    return partenaires.find(el => el.name===string);
    
}

function partenaireNb(number){
    return partenaires[number];
}

function partenairesSize(){
    console.log(partenaires.length);
    return partenaires.length;
}

function donneesSize(){
    return data.length;
}

function donneesAnciennesSize(){
    return dataAnc.length;
}

function donneesPageArtistesActuelsSize(){
    console.log(dataPageArtistesActuels.length);
    return dataPageArtistesActuels.length;

}



export {photosSize, photosNb, donneesPageArtistesActuelsSize, donneesPageArtistesActuelsNb, donneesPageArtistesActuels, partenaireNb, partenairesSize, partenaire, donnees, donneesNb, donneesAnciennes, donneesAnciennesNb, donneesSize, donneesAnciennesSize};

